import {ENUMS} from "./enums";

const updateCollection = (items, payload, toBeginning = false) => {
  const methodEnum = ENUMS.PusherServiceMethodEnum
  const entry = payload.data

  if (payload.method === methodEnum.CreatedMarketEvent.value) {
    const index = items.findIndex((item) => item.id === entry.id)
    if (index === -1 && toBeginning) items.unshift(entry)
    if (index === -1 && !toBeginning) items.push(entry)
  }

  if (payload.method === methodEnum.UpdatedMarketEvent.value) {
    items = items.map((item) => {
      if (item.id === entry.id) return entry
      return item
    })
  }

  if (payload.method === methodEnum.DeletedMarketEvent.value) {
    const index = items.findIndex((item) => item.id === entry.id)
    if (index !== -1) items.splice(index, 1)
  }

  return items
}

const PusherHelper = {
  namespaced: true,
  updateCollection
};

export default PusherHelper;
